import m from "mithril";

const ArnBarWidget = {
    oncreate: (vnode) => {
        // Environments without the widget configured would otherwise request "undefined<userId>"
        const widgetUrl = window.ENV && window.ENV.ARN_WIDGET_URL;
        if (!widgetUrl) return;

        var s = document.createElement('script');
        s.type = "text/javascript";
        s.async = true;
        const userId = vnode.attrs.userId || "";
        s.src = widgetUrl + userId;
        s.onload = () => {
            if (window.arnWidget) {
                new window.arnWidget();
            }
        };
        document.head.appendChild(s);
    },
    view: () => {
        return m("");
    }
};

export default ArnBarWidget;
